import React from 'react';
import Page1 from './page1';
import Page2 from './page2';
import Page3 from './page3';
import Footer from '../Home/Footer'
import Header from '../Home/Navbar'
import './diabetes.css'


const wellnessRoute = () => {
    return (
        <>
            <Header/>
            <Page1/>
            <Page2/>
            <Page3/>
            <Footer/>
        </>
    )
}
export default wellnessRoute;
